import { ApiUserRole } from '@/enum/ApiUserRole'
import { TemplateMail } from '@/enum/TemplateMail'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloAddress extends AloBase {
            
    gpsId: number|null
    ctyId: number
    adrNumberWay: number|null
    adrOutsideInfos: string
    adrPostalCode: string
    adrPostBox: string    
    adrIndoorInfos: string|null
    gpsLat: number|null    
    gpsLon:number|null 
}

export const getDefaultAloAddress = ():AloAddress => {
    return {  
        ...getDefaultAloBase(),        
        gpsId : null,
        ctyId: 0,
        adrNumberWay:null,
        adrOutsideInfos:"",
        adrPostalCode:"",
        adrPostBox:"",        
        adrIndoorInfos:"",
        gpsLat:null,
        gpsLon:null,
    }
}


export const cleanAloAddress = (adresse:AloAddress) => {
    if(!adresse) return    
    if(!adresse.id) delete adresse.id
    if(!adresse.gpsId) delete adresse.gpsId  
    if(!adresse.ctyId) delete adresse.ctyId  
    //if(!adresse.ctyName) delete adresse.ctyName  
}

